//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VocConsole from "@packages/console/src/main"
import mixins from "./mixins"
import { Menu, MenuItem, Dropdown, DropdownMenu, DropdownItem, Dialog } from "element-ui"
import VocServicerQr from "@packages/servicer/src/servicerQr"
// eslint-disable-next-line no-unused-vars

    import Vue from "vue"

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

export default {
  name: "VocHeaderMenuMobile",
  components: {
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Dialog.name]: Dialog,
    VocConsole,
    VocServicerQr
  },
  mixins: [mixins],
  data() {
    return {
      dialogVisible: false,
      languageSwitch: false,
      blackList: ["DATA-CENTER-VOICE-DATA", "CUSTOMER-JOURNEY"]
    }
  },
  methods: {
    changeSwitch(val) {
      if (val) {
        this.onChangeLanguage("en")
      } else {
        this.onChangeLanguage("zh-cn")
      }
    }
  }
}
